export const API_ROUTE =
  import.meta.env.VITE_API_ROUTE || 'http://localhost:3000/api'

export const GA_MEASUREMENT_ID =
  import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-0XZQZVZQZQ'

export const CUSTOMER_PORTAL_URL = import.meta.env.VITE_CUSTOMER_PORTAL

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
